import "./Footer.css";

export default function Footer() {
  return (
    <footer className="app-footer">
      © 2026&nbsp;
      <a
        href="https://eduardo-lulo-portfolio.netlify.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Eduardo Lulo
      </a>
    </footer>
  );
}
